import { HeadingPriority } from "atoms/constants/heading-priority";
import Heading from "atoms/typography/heading";
import React from "react";

export interface PublicationSidebarNavProps {
    title?: string;
    children?: React.ReactNode;
}

const PublicationSidebarNav: React.FC<PublicationSidebarNavProps> = (
    props: PublicationSidebarNavProps
) => {
    const { title } = props;

    return (
        <nav className="c-publication-sidebar-nav">
            <Heading
                cssClassName="c-publication-sidebar-nav__chapter-title"
                priority={HeadingPriority.Four}>
                {title}
            </Heading>
            {props.children}
        </nav>
    );
};

/*
---------------------------------------------------------------------------------------------
#region Exports
---------------------------------------------------------------------------------------------
*/

export default PublicationSidebarNav;

// #endregion Exports
